import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewContainerRef } from "@angular/core";
import { CardAction } from "@features/eda/worksheet/cards/events";
import { CardCreationHelper } from "@features/eda/worksheet/cards/help/card-creation-helper";
import { ModalsService } from "@shared/modals/modals.service";
import { UnitRootTestZA, UnitRootTestZACard } from "src/generated-sources";

@Component({
    selector: 'unit-root-test-za-card-help',
    templateUrl: './unit-root-test-za-card-help.component.html',
    styleUrls: ['./unit-root-test-za-card-help.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitRootTestZACardHelpComponent {
    @Input() params: UnitRootTestZACard;
    @Input() readOnly: boolean;
    @Input() extendedActions: boolean;
    @Output() action = new EventEmitter<CardAction>();

    private cardCreationHelper: CardCreationHelper;

    constructor(
        modalsService: ModalsService,
        viewContainerRef: ViewContainerRef,
    ) {
        this.cardCreationHelper = new CardCreationHelper(
            modalsService,
            viewContainerRef,
            this.action
        );
    }

    get canAddCard() {
        return !this.readOnly && this.extendedActions;
    }

    get stationarityLabel(): string {
        switch (this.params.regressionMode) {
            case UnitRootTestZA.RegressionMode.CONSTANT_ONLY:
                return "stationary";

            case UnitRootTestZA.RegressionMode.TREND_ONLY:
            case UnitRootTestZA.RegressionMode.CONSTANT_WITH_TREND:
                return "trend stationary";
        }
    }

    addACFPlotCard() {
        if (this.canAddCard) {
            this.cardCreationHelper.createACFPlotCard(this.params);
        }
    }

    addDurbinWatsonCard() {
        if (this.canAddCard) {
            this.cardCreationHelper.createDurbinWatsonCard(this.params);
        }
    }
}
